// extracted by mini-css-extract-plugin
export default {"form":"Map-Season_form__b42n7","formFooter":"Map-Season_formFooter__0SktH"};